export default __webpack_public_path__ + "static/media/Credit2.4366275f.svg";